<template>
  <v-card
    :loading="store.fetchingFlags.tiposDeMensajeria"
    :disabled="store.fetchingFlags.tiposDeMensajeria"
    flat
  >
    <v-container>
      <v-row>
        <v-col cols="12">
          <FormField
            v-model="store.formData.personaRecibiraMensajeria"
            field-type="v-text-field"
            label="Persona que Recibira la Mensajeria"
            :rules="[rules.required]"
            class="mt-2"
          />
        </v-col>
        <v-col cols="12" md="6">
          <FormField
            v-model="store.formData.fechaEntrega"
            field-type="v-date-input"
            label="Fecha de Entrega"
            hide-actions
            prepend-icon=""
            class="mt-2"
            :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="12" md="6">
          <FormField
            v-model="store.formData.horarioMensajeria"
            field-type="v-select"
            label="Horario de Mensajeria"
            :items="horariosDeMensajeria"
            :rules="[rules.required]"
            class="mt-2"
          />
        </v-col>
        <v-col cols="12" md="6">
          <FormField
            v-model="store.formData.tipoMensajeria"
            field-type="v-select"
            label="Tipo de Mensajeria"
            :items="
              store.apiCache.tiposDeMensajeria.length
                ? store.apiCache.tiposDeMensajeria
                : store.defaultTiposDeMensajeria
            "
            :rules="[rules.required]"
            class="mt-2"
          />
        </v-col>
        <v-col cols="12" md="6" v-if="store.showTituloCorreo">
          <FormField
            v-model="store.formData.tituloCorreo"
            field-type="v-textarea"
            label="Titulo de Correo"
            rows="1"
            :rules="[rules.required]"
            class="mt-2"
          />
        </v-col>
        <v-col cols="12">
          <FormField
            v-model="store.formData.comentariosAdicionales"
            field-type="v-textarea"
            rows="2"
            class="mt-2"
          >
            <template v-slot:label>
              Comentarios Adicionales<small class="text-caption">
                - Opcional</small
              >
            </template>
          </FormField>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script setup>
import { useSolicitudMensajeriaStore } from "@/stores/solicitudMensajeria";
import FormField from "./FormField.vue";

const store = useSolicitudMensajeriaStore();

const horariosDeMensajeria = ["09:30 hrs", "13:00 hrs", "16:00 hrs"];
// const tiposDeMensajeria = ["Entrega de Documentos", "Recolectacion de Documentacion", "Envio de Cheque", "Envio de Efectivo"]

const rules = {
  required: (value) => !!value || "Campo requerido",
};
</script>
